import { CEPersonAttributesBase } from './ce-person-attributes-base'


export class CEPersonAttributes extends CEPersonAttributesBase {

}